export default __webpack_public_path__ + "static/media/section2-bg5.d963dc08.png";